import { ScrollArea } from '@/components/shadcn/scroll-area'
import { useSessionStorage } from '@/hooks'
import { AppMenu, SupportPanel } from '@/unity-apps/components'
import { MenuLoading } from '@/unity-apps/components/AppMenu/AppMenu'
import { AppSupportMenu, AppSupportMenuLoading, SupportPanelView } from '@/unity-apps/components/AppSupportMenu'
import { SupportPanelComponentRenderer } from '@/unity-apps/components/SupportPanel'
import { isSuperUser } from '@/util'
import { LayoutGroup, motion } from 'motion/react'
import { Suspense, useState } from 'react'
import { Navigate, Outlet } from 'react-router'

export type SupportPanelState = {
  supportPanelView?: SupportPanelView
  setSupportPanelView: React.Dispatch<React.SetStateAction<SupportPanelView | undefined>>
}

export function UnityLayout() {
  // Temporarily restrict access to Super Users while in development
  const [roles] = useSessionStorage('roles', 0)
  if (!isSuperUser(roles)) {
    return <Navigate to="/" />
  }

  return (
    <LayoutGroup>
      <motion.div
        layout
        className="grid h-[calc(100vh-86px)] grid-cols-[min-content_max-content_1fr] [&>div]:h-[calc(100vh-86px)]"
      >
        <Outlet />
      </motion.div>
    </LayoutGroup>
  )
}

export function UnityAppLayout() {
  const [supportPanelView, setSupportPanelView] = useState<SupportPanelView>()
  return (
    <>
      <motion.div layout className="flex flex-col justify-between gap-y-5">
        <ScrollArea className="flex-1 p-5">
          <Suspense fallback={<MenuLoading />}>
            <AppMenu />
          </Suspense>
        </ScrollArea>
        <div className="h-min w-full pb-5 pl-5">
          <Suspense fallback={<AppSupportMenuLoading />}>
            <AppSupportMenu setSupportPanelView={setSupportPanelView} />
          </Suspense>
        </div>
      </motion.div>
      <motion.div layout className="bg-white">
        <SupportPanel supportPanelView={supportPanelView} setSupportPanelView={setSupportPanelView}>
          <SupportPanelComponentRenderer
            supportPanelView={supportPanelView}
            setSupportPanelView={setSupportPanelView}
          />
        </SupportPanel>
      </motion.div>
      <motion.div layout className="h-full w-full">
        <Outlet />
      </motion.div>
    </>
  )
}
